import * as yup from "yup";
import { createValidationSchema, validate, validateIfFile } from "@";

// Schemas
export const bankAccountsSchema = createValidationSchema({
  name: validate("req", "name"),
  iban: validate("iban", "iban"),
  bank: validate("req", "bank"),
  isDefault: yup.boolean().default(false),
});

export const classificationsSchema = createValidationSchema({
  Name: validate("req", "name"),
  Order: validate("number", "Order"),
  IsActive: yup.boolean().default(true),
  ShowOnHomePage: yup.boolean().default(true),
  ShowOnFastDonation: yup.boolean().default(true),
});

export const infoSchema = createValidationSchema({
  tiktok: validate("nullableUrl", "tiktok"),
  email: validate("nullableEmail", "email"),
  twitter: validate("nullableUrl", "twitter"),
  youtube: validate("nullableUrl", "youtube"),
  website: validate("nullableUrl", "website"),
  phone: validate("nullablePhone", "whatsapp"),
  snapChat: validate("nullableUrl", "snapChat"),
  faceBook: validate("nullableUrl", "faceBook"),
  instagram: validate("nullableUrl", "instagram"),
  whatsapp: validate("nullablePhone", "whatsapp"),
  donationWebSite: validate("nullableUrl", "donationWebSite"),
});

export const contactSchema = createValidationSchema({
  ceoEmail: validate("nullableEmail", "ceoEmail"),
  ceoPhone: validate("nullablePhone", "phone number"),
  techManagerPhone: validate("nullablePhone", "phone number"),
  websiteManagerPhone: validate("nullablePhone", "phone number"),
  techManagerEmail: validate("nullableEmail", "techManagerEmail"),
  websiteManagerEmail: validate("nullableEmail", "websiteManagerEmail"),
  websiteManagerNotificationNumber: validate("nullablePhone", "phone number"),
});

export const licensesSchema = createValidationSchema({
  title: validate("req", "title"),
  issuer: validate("req", "issuer"),
  licence: validateIfFile("image", "imageFullUrl"),
  issueDate: validate("date", "issueDate"),
  isDefault: yup.boolean().default(false),
});

export const bankSchema = createValidationSchema({
  name: validate("req", "name"),
  image: validateIfFile("image", "imageFullUrl"),
  isActive: yup.boolean().default(true),
});

// Default Values
export const bankDefaultValues = {
  id: null,
  name: "",
  image: null,
  imageFullUrl: null,
  isActive: true,
};

export const bankAccountsDefaultValues = {
  id: null,
  name: "",
  iban: "",
  bank: "",
  isDefault: false,
};

export const classificationsDefaultValues = {
  id: null,
  Order: 0,
  Name: null,
  Image: null,
  Banner: null,
  IsActive: true,
  imageFullUrl: null,
  ShowOnHomePage: true,
  ShowOnFastDonation: true,
};

export const infoDefaultValues = {
  businessTypes: [],
  showCharityName: false,
  locationOnMap: { lat: null, lng: null },
};

export const interfaceDefaultValues = {
  customCss: "",
  themeValues: "",
  colorA: "#000000",
  colorB: "#000000",
  colorC: "#000000",
};

export const licensesDefaultValues = {
  id: null,
  title: null,
  issuer: null,
  licence: null,
  issueDate: null,
  isDefault: false,
};
